import { ReactComponent as PlaySvgIcon } from "../../../assets/icons/Icon/DKT/Player/Play Circle white.svg";
import { ReactTFC } from "../../../utils/fp/missing-ts-parts";

import { css } from "@emotion/react";
import { VideoTeaserType } from "@swo/storefront";
import { CSS_MQ } from "../../../styles/breakpoints";
import { ContentfulImage2 } from "../../_shared-components/image-related/ContentfulImage2";

export const FocalImageWithPlayButton: ReactTFC<{
  image: VideoTeaserType["imageWithFocalPoint"];
  onClick?: () => void;
  imageSizes?: string;
}> = props => {
  return (
    <>
      <ContentfulImage2
        assetId={props.image.image.sys.id}
        contentfulUrl={props.image.image.url}
        cropping={props.image}
        sizes={props.imageSizes}
        loading={"lazy"}
        css={css`
          filter: brightness(0.7);

          position: absolute;
          top: 0;
          left: 0;
          width: 100%;
          height: 100%;

          cursor: pointer;
        `}
        withTransparency={false}
      />
      <PlayIconWithWrapper onClick={props.onClick} />
    </>
  );
};

export const PlayIconWithWrapper: ReactTFC<{ className?: string; onClick?: () => void }> = props => {
  return (
    <span
      onClick={props.onClick}
      className={props.className}
      css={css`
        top: 0;
        left: 0;

        position: absolute;
        width: 100%;
        height: 100%;

        display: flex;
        justify-content: center;
        align-items: center;

        cursor: pointer;
      `}
    >
      <PlaySvgIcon
        css={css`
          width: 54px;
          height: 54px;

          ${CSS_MQ.atLeastMd} {
            width: 72px;
            height: 72px;
          }
        `}
      />
    </span>
  );
};
